// Form validation constants
export const FIELD_NAMES = {
  EMAIL_ADDRESS: "Email Address",
} as const;

export const VALIDATION_PATTERNS = {
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
} as const;

export const VALIDATION_MESSAGES = {
  REQUIRED: (fieldName: string) => `${fieldName} is required.`,
  INVALID_EMAIL: "Please enter a valid email address.",
} as const;
